import {
  IPublicClientApplication,
  PopupRequest,
  SilentRequest,
} from "@azure/msal-browser";

// New Auth Utils file, to be separated from original credentials.ts (this is out of date due to Azure Communication Service library change)
export async function getAccessToken(
  instance: IPublicClientApplication,
  loginRequest: SilentRequest | PopupRequest
) {
  const account = instance.getAllAccounts()[0];

  console.log(account);

  if (!account) {
    throw new Error("[ERROR] No account is signed in.");
  }

  const request = {
    ...loginRequest,
    account: account,
  };

  try {
    const response = await instance.acquireTokenSilent(request);
    localStorage.setItem("accessToken", response.accessToken);
    return response.accessToken;
  } catch (silentError) {
    const response = await instance.acquireTokenPopup(request);
    localStorage.setItem("accessToken", response.accessToken);
    return response.accessToken;
  }
}
